module.exports = __webpack_public_path__ + "img/new_06.d1fb2a87.jpg";